module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAARUlEQVQ4jWP8//8/Ax5wGCpli0sJIQNgkoy4FDDh000MGDUAYsBhaGhjw8ixgQ0fptQFjKPpYDAYwEJA/gi+GGBgYGAAAGfQGldOj+rlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon9.png
// module id = 7nKI
// module chunks = 0